/**
 *
 * QualitativeQuestionList
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { isEqual, debounce } from "lodash"
import { Spin, Pagination, Empty } from "antd"
import { makeSelectIsLoadingAnswers, makeSelectAnswers } from "./selectors"
import reducer from "./reducer"
import saga from "./saga"
import QuestionCard from "../../../components/QuestionCard"
import empty_meditions from "../../../images/emptyQuestionsReports.svg"
import { getQualitativeAnswersWatcher } from "./actions"
import "./index.less"
import { isAmbassadorActive } from "../../../utils/storage"
/* eslint-disable react/prefer-stateless-function */
export class QualitativeQuestionList extends React.Component {
  state = {
    questions: [],
    columns: [],
    paginationCurrentPage: 1,
    paginationPageSize: this.props.total ? this.props.total : 15,
    rows: [],
  }

  generate = () => {
    const { answers } = this.props
    const { rows } = this.state
    let initial = 1
    const newCol = []
    if (Array.isArray(rows)) {
      rows.map((e) => {
        if (!newCol[initial - 1]) {
          newCol[initial - 1] = []
        }
        newCol[initial - 1].push(e)
        initial++
        if (initial === 4) {
          initial = 1
        }
      })
      this.setState(
        { columns: newCol },
        this.props.totalAnswers(answers.length)
      )
    }
  }

  componentDidUpdate(nextProps) {
    if (!isEqual(nextProps.answers, this.props.answers)) {
      this.onChange(1)
    }
  }

  onChange = (page) => {
    const { answers } = this.props
    const { paginationPageSize } = this.state
    this.setState({ paginationCurrentPage: page }, () => {
      const startIndex = (page - 1) * paginationPageSize
      const endIndex = Math.min(
        startIndex + paginationPageSize - 1,
        answers.length - 1
      )
      const rows = answers.slice(startIndex, endIndex + 1)
      this.setState({ rows }, () => this.generate())
    })
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ paginationPageSize: pageSize }, () => {
      this.onChange(1)
    })
  }

  debounceGetQualitativeAnswers = debounce(() => {

    if(isAmbassadorActive()){
      if(!this.props.ambassadorDivisionSelected || !this.props.division || !this.props.measure){
        // return false
      }
    }

    if (this.props.question) {
      this.props.getQualitativeAnswers({
        measure: this.props.measure,
        question: this.props.question,
        division: this.props.division,
        params: {
          id_division: this.props.ambassadorDivisionSelected,
          id_segment: this.props.selectedSegment,
        },
      })
    }
  }, 2000)

  componentDidMount() {
    this.debounceGetQualitativeAnswers()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.question != this.props.question ||
      nextProps.division != this.props.division
    ) {
      this.debounceGetQualitativeAnswers()
    }
  }

  render() {
    const { columns, paginationCurrentPage } = this.state
    const { isLoadingAnswers, pagination, answers } = this.props

    if (isLoadingAnswers) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }
    if (!answers.length) {
      return (
        <div>
          <Empty
            style={{ color: "#828282" }}
            image={empty_meditions}
            description={
              <span
                style={{ margin: "0 auto", maxWidth: 440, display: "block" }}>
                ¡Aún no se cuenta con un resultado!
              </span>
            }
            className="ReportsHome-empty-fix"
          />
        </div>
      )
    }

    return (
      <div style={{ ...(typeof window.Intercom !== "undefined" &&
        window.self === window.top && {
        paddingBottom: "50px"}) }}>
        <div className="QualitativeQuestionList">
          {columns.map((c, ci) => {
            return (
              <div key={ci} className="QualitativeQuestionList-column">
                {c.map((q, i) => (
                  <QuestionCard key={i} title={q.name} description={q.value} />
                ))}
              </div>
            )
          })}
        </div>
        {pagination && (
          <Pagination
            defaultPageSize={this.props.total ? this.props.total : 15}
            pageSizeOptions={["15", "25", "50", "100"]}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            onChange={this.onChange}
            defaultCurrent={paginationCurrentPage}
            total={Array.isArray(answers) ? answers.length : 0}
          />
        )}
      </div>
    )
  }
}
QualitativeQuestionList.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isLoadingAnswers: makeSelectIsLoadingAnswers(),
  answers: makeSelectAnswers(),
})

function mapDispatchToProps(dispatch) {
  return {
    getQualitativeAnswers: (params) =>
      dispatch(getQualitativeAnswersWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "qualitativeQuestionList", reducer })
const withSaga = injectSaga({ key: "qualitativeQuestionList", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(QualitativeQuestionList)
